"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditSingleObjective = void 0;
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("client/ObjectivesClient");
const useEditSingleObjective = (objectiveId) => {
    return (0, react_query_1.useMutation)((body) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield (0, ObjectivesClient_1.editObjective)(objectiveId, body);
        if (response === null || response === void 0 ? void 0 : response.isSuccess) {
            return response;
        }
        throw response;
    }));
};
exports.useEditSingleObjective = useEditSingleObjective;
